import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/terms.scss";

function Terms() {
  const { brandName, contact } = siteConfig;

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="terms terms-page">
      <header className="terms-page__hero">
        <p>Legal / Store terms</p>
        <h1>Terms &amp; conditions</h1>
        <span>Last updated: August 2026</span>
      </header>

      <div className="terms-page__layout">
        <nav
          className="terms-page__nav"
          aria-label="Terms and conditions contents"
        >
          <p>On this page</p>
          <a href="#terms-scope">Scope</a>
          <a href="#terms-orders">Orders</a>
          <a href="#terms-prices">Prices and payment</a>
          <a href="#terms-delivery">Delivery</a>
          <a href="#terms-returns">Returns</a>
          <a href="#terms-liability">Product responsibility</a>
          <a href="#terms-contact">Contact</a>
        </nav>

        <article className="terms-page__content">
          <section id="terms-scope">
            <p className="terms-page__kicker">The essentials</p>
            <h2>Clear terms for a straightforward order.</h2>
            <p>
              These terms apply when you purchase products through the
              {` ${brandName} `}online store. By submitting an order, you
              confirm that you can enter into a purchase agreement and that the
              details you provide are complete and accurate.
            </p>
          </section>

          <section id="terms-orders">
            <h2>1. Orders and acceptance</h2>
            <p>
              Product pages are an invitation to order. Your order is placed
              when you complete checkout; a binding sale is created when we send
              an order confirmation. If an item becomes unavailable or we cannot
              accept the order, we will notify you and return any amount already
              paid for that item.
            </p>
          </section>

          <section id="terms-prices">
            <h2>2. Prices and payment</h2>
            <p>
              Prices are shown in the currency selected for the storefront.
              Applicable taxes are displayed at checkout. Delivery costs and any
              available discounts are shown before you place the order. Payment
              is collected through the methods offered during checkout.
            </p>
          </section>

          <section id="terms-delivery">
            <h2>3. Delivery</h2>
            <p>
              Delivery windows are estimates and begin after processing. Events
              outside our reasonable control can affect timing. Please check the
              address carefully; additional costs caused by an incorrect or
              incomplete address may be passed on where allowed by law.
            </p>
            <Link to="/shipping" onClick={toTop}>
              View shipping details <span>↗</span>
            </Link>
          </section>

          <section id="terms-returns">
            <h2>4. Cancellations, returns and refunds</h2>
            <p>
              Eligible unworn items may be returned within the period shown in
              our returns policy. Your statutory rights remain unaffected.
              Refunds are made to the original payment method after the return
              has been received and checked.
            </p>
            <Link to="/returns" onClick={toTop}>
              Read the returns policy <span>↗</span>
            </Link>
          </section>

          <section id="terms-liability">
            <h2>5. Products and responsibility</h2>
            <p>
              We take reasonable care to describe and photograph products
              accurately. Screen settings and the natural character of fibers
              can create small variations in color or texture. Nothing in these
              terms excludes rights or remedies that cannot legally be limited.
            </p>
          </section>

          <section id="terms-contact">
            <h2>6. Questions</h2>
            <p>
              Contact us at{" "}
              <a href={`mailto:${contact.email}`}>{contact.email}</a>, , or
              write to {contact.address}.
            </p>
            <Link to="/contact" onClick={toTop} className="terms-page__button">
              Contact customer care
            </Link>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Terms;
